import { render, staticRenderFns } from "./V2CreateSelectionModal.vue?vue&type=template&id=7612d950&scoped=true&"
import script from "./V2CreateSelectionModal.vue?vue&type=script&lang=js&"
export * from "./V2CreateSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./V2CreateSelectionModal.vue?vue&type=style&index=0&id=7612d950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7612d950",
  null
  
)

export default component.exports